// extracted by mini-css-extract-plugin
export default {"header":"header_header__hXWLQ","border":"header_border__tOAr4"};